export default {
  cardLabelUglyIphones: {
    id: 'outlet_card_label_ugly_iphones',
    defaultMessage: 'Ugly iPhones',
  },
  cardLabelUglyMacbooks: {
    id: 'outlet_card_label_ugly_macbooks',
    defaultMessage: 'Ugly MacBooks',
  },
}
